import React from 'react';
import { useTranslation } from 'localization';
import SphereAvatar from '../sphere-avatar/sphere-avatar';
import type { GlyphColor } from '../../../types/glyph';
import './TaskListGroupHeaderMolecule.scss';

export interface TaskListGroupHeaderMoleculeProps {
  sphereId: string;
  sphereName: string;
  taskCount: number;
  collapsed: boolean;
  onToggle: (sphereId: string) => void;
  glyph?: string;
  glyphColor?: GlyphColor;
  imageId?: string;
  className?: string;
  hasOverdue?: boolean;
}

const TaskListGroupHeaderMolecule: React.FC<TaskListGroupHeaderMoleculeProps> = ({
  sphereId,
  sphereName,
  taskCount,
  collapsed,
  onToggle,
  glyph,
  glyphColor,
  imageId,
  className = '',
  hasOverdue = false,
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    onToggle(sphereId);
  };

  return (
    <button
      type="button"
      className={`task-list-group-header-molecule ${collapsed ? 'task-list-group-header-molecule--collapsed' : ''} ${hasOverdue ? 'task-list-group-header-molecule--has-overdue' : ''} ${className}`}
      onClick={handleClick}
      aria-expanded={!collapsed}
    >
      <div className="task-list-group-header-molecule__avatar">
        <SphereAvatar
          sphereId={sphereId}
          sphereName={sphereName}
          glyph={glyph}
          glyphColor={glyphColor}
          imageId={imageId}
          size="small"
          shape="circle"
          showInitials={!glyph && !imageId}
          decorative
        />
      </div>
      <span className="task-list-group-header-molecule__name">
        {sphereName}
      </span>
      <span className="task-list-group-header-molecule__count">
        {t('contextTasks.group.taskCount', { count: taskCount })}
      </span>
      <i
        className={`task-list-group-header-molecule__chevron pi ${collapsed ? 'pi-chevron-right' : 'pi-chevron-down'}`}
        aria-hidden="true"
      />
    </button>
  );
};

export default TaskListGroupHeaderMolecule;
